var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",class:{ full: _vm.fullscreen },attrs:{"allow":"microphone; fullscreen","id":"ifr","height":_vm.height,"src":_vm.src,"allowfullscreen":"","frameborder":"0"},on:{"load":_vm.onIframeLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }